import "../../styles/AdminDashboard.css";

function DashboardTabs({ activeTab, setActiveTab }) {
  return (
    <div className="adminDash__tabs">
      {[
        { key: "users", label: "User Registrations" },
        { key: "datasets", label: "Soil Datasets" },
      ].map(({ key, label }) => (
        <button
          key={key}
          type="button"
          className={`adminDash__tab ${activeTab === key ? "adminDash__tab--active" : ""}`}
          onClick={() => setActiveTab(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default DashboardTabs;
